import LeaveCreditRequest from '../view/module/LeaveCreditRequest'
import LeaveRequest from '../view/module/LeaveRequest'

export const iconConstructor = (type) => {
  switch (type) {
    case 1:
      return 'calendar_today'
    case 2:
      return 'add'
    default:
      return null
  }
}

export const typeIntToString = (int) => {
  switch (int) {
    case 1:
      return 'leave'
    case 2:
      return 'leave-claim'
    default:
      return null
  }
}

export const HeaderText = (type) => {
  switch (type) {
    case 1:
      return 'Leave request'
    case 2:
      return 'Leave credit request'
    default:
      return null
  }
}
export const footerText = (type) => {
  switch (type) {
    case 1:
      return 'Total leave'
    case 2:
      return 'Total leave credit'
    default:
      return null
  }
}

export const statuBarSelector = (currentTab) => {
  switch (currentTab) {
    case 'pending':
      return 'PENDING'
    case 'upcoming':
      return {
        text: 'Upcoming',
        color: 'light-gray-text.main',
        bgColor: 'gray-background.main',
      }
    case 'responded':
      return {
        text: 'Responded',
        color: 'light-gray-text.main',
        bgColor: 'gray-background.main',
      }
    case 'completed':
      return {
        text: 'Completed',
        color: 'light-gray-text.main',
        bgColor: 'gray-background.main',
      }
    case 'reimbursement':
      return 'REIMBURSED'
    default:
      return null
  }
}

export const ModuleRequestRender = (
  id,
  type,
  editable,
  setReject,
  setApprove,
  setMutation,
  requestId
) => {
  switch (type) {
    case 1:
      return (
        <LeaveRequest
          id={id}
          editable={editable}
          setReject={setReject}
          setApprove={setApprove}
          requestId={requestId}
          setMutation={setMutation}
        />
      )
    case 2:
      return (
        <LeaveCreditRequest
          id={id}
          editable={editable}
          setReject={setReject}
          setApprove={setApprove}
          requestId={requestId}
          setMutation={setMutation}
        />
      )
    default:
      return null
  }
}
